import React, { useRef } from "react";
import FileFormat from "./FileFormat";
import Thumbnail from "./Thumbnail";
import "./FilesView.css";
import Popup from 'reactjs-popup';
import { Link } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
const FilesViewContent = (props) => {
const ref=useRef();
const closeTooltip = () => ref.current.close();
  return (
    <>
      <div className="col-md-3" style={{ margin: "auto", marginBottom: "10px" }}>

        <div className="card p-1 noselect">
          {props.showOptions ? <div class="card-header" style={{ backgroundColor: "unset",display:"flex",justifyContent:"space-between" }} >
            <div>{props.category}({props.exam})</div>
            <Popup
            
            ref={ref}
              trigger={open => (
                <button className="button deleteFacultyFile" style={{cursor: "pointer",border:"none",outline:"none",background:"none" }}><BsThreeDotsVertical/></button>
              )}
              position="left center"
              closeOnDocumentClick
            >
              <div onClick={closeTooltip}>
              <button type="button" style={{border:"none",outline:"none",background:"none",width:"100%"}} className="filesInfoToolTip" onClick={()=>(props.showOptions.onDelete(props._id))}> Delete </button>
              </div>
              
            </Popup>
          </div> : <></>}
          <Link
            key={props._id}
            to={props.showOptions ? (`${props._id}?year=${props.year}&sem=${props.sem}&branch=${props.branch}`) : (`${props._id}?category=${props.category}&exam=${props.exam}`)}
            style={{ textDecoration: "inherit", color: "inherit", display: "flex", flexDirection: "column" }}
          >
            <Thumbnail {...props} />
            <div class="card-body unitname">
              <FileFormat {...props} />
              <h5 className="filename">{props.name}</h5>
            </div>
          </Link>
        </div>

      </div>
    </>
  );
};

export default FilesViewContent;
